import en from 'dayjs/locale/en';
import ru from 'dayjs/locale/ru';

const dayjsLocales = {
  en,
  ru,
};

export const getDayjsLocale = (ln) => dayjsLocales[ln] || null;
